export default __webpack_public_path__ + "static/media/rakesh.a38283ef.png";